import * as type from '../../types/API/imageUploadTypes';

export function uploadImage(payload: FormData) {
    return {
        type: type.UPLOAD_IMAGE,
        payload: payload,
    };
}

